// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__33r_k","tab_item":"Tabs_tab_item__2No7H"};